import type { TierId } from "@/components/PricingTiers";

export interface ClubResult {
  clubName: string;
  clubPermanentId: string;
  address: string;
  logoUrl: string;
  teams: TeamResult[];
}

export interface TeamResult {
  teamPermanentId: string;
  teamName: string;
  category: string;
  teamUrl: string;
  logoUrl: string;
}

export interface SelectedTeam {
  teamPermanentId: string;
  teamName: string;
  category: string;
  teamUrl: string;
  tag: string;
}

// Preise (EUR pro Monat)
export const BASE_PRICE = 20;
export const EXTRA_TEAM_PRICE = 10;
export const YOUTH_PACK_PRICE = 25;
export const INSTAGRAM_PRICE = 7;
/** Maximale Anzahl Mannschaften insgesamt mit Jugend-Paket. */
export const JUGEND_MAX = 10;
/** Ab so vielen Zusatzmannschaften lohnt sich das Jugend-Paket. */
export const YOUTH_PACK_BREAK_EVEN = 3;

export function defaultTeamTag(teamName: string, category = ""): string {
  const name = `${teamName || ""} ${category || ""}`.toLowerCase();
  if (/\ba[-\s]?junior|\bu\s?19\b/.test(name)) return "#a-jugend";
  if (/\bb[-\s]?junior|\bu\s?17\b/.test(name)) return "#b-jugend";
  if (/\bc[-\s]?junior|\bu\s?15\b/.test(name)) return "#c-jugend";
  if (/\bd[-\s]?junior|\bu\s?13\b/.test(name)) return "#d-jugend";
  if (/\be[-\s]?junior|\bu\s?11\b/.test(name)) return "#e-jugend";
  if (/\bf[-\s]?junior|\bu\s?9\b/.test(name)) return "#f-jugend";
  if (/ü\s?32|ue\s?32|alte herren/.test(name)) return "#ue32";
  if (/frauen|damen/.test(name)) return "#frauen";
  if (/\biii\b|\b3\./.test(name)) return "#dritte";
  if (/\bii\b|\b2\.|zweite/.test(name)) return "#zweite";
  return "#erste";
}

export function monthlyTotal(
  teamCount: number,
  youthPack: boolean,
  instagram: boolean,
): number {
  const extras = Math.max(0, teamCount - 1);
  const teamsCost = youthPack ? YOUTH_PACK_PRICE : extras * EXTRA_TEAM_PRICE;
  return BASE_PRICE + teamsCost + (instagram ? INSTAGRAM_PRICE : 0);
}

export interface WizardState {
  club: {
    clubName: string;
    clubPermanentId: string;
    logoUrl: string;
    address: string;
  } | null;
  clubTeams: TeamResult[];
  teams: SelectedTeam[];
  branding: {
    logoDataUrl: string | null;
    primaryColor: string;
    secondaryColor: string; // kept for legacy compatibility; not user-editable
  };
  selectedTier: TierId;
  billingCycle: "monthly" | "yearly";
  designId: string;
  youthPack: boolean;
  instagramEnabled: boolean;
  telegramCode: string;
  email: string;
  password: string;
}

export const INITIAL_WIZARD_STATE: WizardState = {
  club: null,
  clubTeams: [],
  teams: [],
  branding: {
    logoDataUrl: null,
    primaryColor: "#1B5EAB",
    secondaryColor: "#FFFFFF",
  },
  selectedTier: "m",
  billingCycle: "monthly",
  designId: "1",
  youthPack: false,
  instagramEnabled: false,
  telegramCode: "",
  email: "",
  password: "",
};

export const DESIGN_OPTIONS = Array.from({ length: 16 }, (_, index) => {
  const id = String(index + 1);
  return { id, name: `Design ${id}`, description: "", templateId: id };
});

export const STORAGE_KEY = "torflash_signup_wizard";
